export default __webpack_public_path__ + "static/media/arrow-left.30f2d50c.svg";